import { handleAddressString } from "app/functions/string";
import { decimalAdjust } from "app/functions/numbers";

export interface InterfaceBet {
  wallet: string;
  amount: number;
  bet: string;
  betId?: string;
}
class Bet {
  public wallet: string;
  public amount: number;
  public bet: string;
  public betId: string;

  constructor({ wallet, amount, bet, betId = "" }: Bet & { betId?: string }) {
    this.wallet = wallet;
    this.amount = decimalAdjust("ceil", amount, -5);
    this.bet = bet;
    this.betId = betId;
  }

  getParticipant(len: string) {
    switch (len) {
      case "short":
        return handleAddressString(this.wallet);

      default:
        return this.wallet;
    }
  }
}

export default Bet;
